import script from "./PreviewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewPage.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewPage.vue?vue&type=style&index=0&id=5191de33&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5191de33"]])

export default __exports__